import React from "react";
import { Suspense, useEffect, useRef, useState } from "react";
import {
  getFullURLDetails,
  getVideo,
  getTicker,
  getYoutubeVideo,
} from "../api/core";
import "../landscapeSlider/landscapeSlider.css";
import "../portraitSlider/portraitSlider.css";
import { getAWSUrl } from "../api/core";
import { Row, Col, Container } from "react-bootstrap";
import "../live/live.css";
import "./page.css";
import { Helmet } from "react-helmet";
import CarouselContentLoader from "../loader/contentLoader";
import InfiniteScroll from "react-infinite-scroll-component";
import Head from "../head/head";
import ErrorBoundary from "../error/error";
import user from "../../user";
import Global from "../../global";
import InPlayer from "../backend/inplayer";
import JWPlayer from "@jwplayer/jwplayer-react";
import YoutubePlayer from "../boxedPlayer/youtubePlayer";
import YoutubeDetails from "../boxedDetails/youtubeDetails";
import YoutubeList from "../featuredList/youtubeList";
import { useHistory } from "react-router-dom";
import External from "../Link/external";
import Internal from "../Link/internal";
import { useTranslation } from "react-i18next";
import LiveFull from "../boxedPlayer/livefull";
const Element = React.lazy(() => import("../element/element"));
const NotFound = React.lazy(() => import("../notfound/notfound"));
const ArticleHeader = React.lazy(() =>
  import("../articleHeader/articleHeader")
);
const BlockQuote = React.lazy(() => import("../blockquote/blockquote"));
const TextView = React.lazy(() => import("../textView/textView"));
const ImageView = React.lazy(() => import("../imageView/imageView"));
const ArticlePlayer = React.lazy(() => import("../boxedPlayer/articlePlayer"));
const ImageSlider = React.lazy(() => import("../newsCarousel/imageSlider"));
const Banner = React.lazy(() => import("../banner/banner"));
const Ticker = React.lazy(() => import("../Ticker/ticker"));
const DetailsTab = React.lazy(() => import("../detailsTab/detailsTab"));
const MovieTab = React.lazy(() => import("../detailsTab/movieTab"));
const MovieBanner = React.lazy(() => import("../banner/moviebanner"));
const Listloader = React.lazy(() => import("../loader/listloader"));
const CLandscapeSlider = React.lazy(() =>
  import("../landscapeSlider/clandscape")
);
const ArticleSlider = React.lazy(() =>
  import("../articleSlider/articleSlider")
);
const TextPage = React.lazy(() => import("../text/text"));

const StartPage = (props) => {
  const [page, setPage] = useState([]);
  const { t } = useTranslation(["translation"]);
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [web, SetWeb] = useState(true);
  const [vPlay, setVPlay] = useState([]);
  const [vData, setVData] = useState(null);
  const [tickStatus, SetTickStatus] = useState("");
  const [tick, setTick] = useState([]);
  const [itemNum, setItemNum] = useState(0);
  const [totNum, settotNum] = useState(0);
  const [itemSkip, setItemSkip] = useState(0);
  const [hasHigh, sethasHigh] = useState(true);
  const [pageItem, setPageItem] = useState([]);
  const mounted = useRef(false);
  const history = useHistory();

  const goBack = () => {
    // watchHistory(second,props.match.params.Id);
    history.goBack();
  };

  useEffect(() => {
    mounted.current = true;

    isLoading(true);
    sethasHigh(true);

    const PageDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */
      const result = await getFullURLDetails(app, id, 0, 4).then(
        (result) => {
          if (mounted.current && result.data) {
            setPage(result.data);
            setPageItem(result.data?.items);
            settotNum(result.data?.itemCount);
            setItemNum(result.data?.devices[0].itemSize);
            SetWeb(result.data?.devices[0].itemVisibility);
            setItemSkip(0);
            SetError(false);
            getTickerDetail(app, result.data?._id);
            if (result.data?.pageType === "videoPage") {
              PLSplaylistDetail(result.data?.videoId);
            }
            if (result.data?.itemCount <= 4) {
              sethasHigh(false);
            }
          }
          isLoading(false);
        },
        (error) => {
          SetError(true);
          isLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const PLSplaylistDetail = async (id) => {
      /* eslint-disable no-unused-vars */
      if (Global.VCMS === "YouTube") {
        const result = await getYoutubeVideo(id).then(
          (result) => {
            if (mounted.current) {
              setVPlay(result.data?.items[0]);
              setVData(result.data);
            }
          },
          (error) => {}
        );
      } else {
        const result = await getVideo(id).then(
          (result) => {
            if (mounted.current) {
              setVPlay(result.data?.playlist[0]);
              setVData(result.data);
            }
          },
          (error) => {}
        );
      }

      /* eslint-disable no-unused-vars */
    };
    const getTickerDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */
      const result = await getTicker(app, id).then(
        (result) => {
          if (mounted.current) {
            setTick(result.data);
            SetTickStatus(result.status);
          }
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
    };

    if (mounted.current) {
      PageDetail(
        props.match.params.AppId,
        props.match.params.urlName ? props.match.params.urlName : "home"
      );
    }

    return () => {
      mounted.current = false;
    };
  }, [props.match.params.AppId, props.match.params.urlName]);

  const fetchData = async () => {
    const length = pageItem.length;
    if (totNum === pageItem.length || itemSkip >= totNum) {
      sethasHigh(false);
    }

    if (totNum !== pageItem.length || itemSkip <= totNum) {
      try {
        const appl = await getFullURLDetails(
          props.match.params.AppId,
          props.match.params.urlName ? props.match.params.urlName : "home",
          itemSkip + 4,
          4
        );

        const pages = appl.data.items;

        const imageCount = appl.data.itemCount;
        setItemSkip(itemSkip + 4);
        if (pages.length !== 0) {
          setItemNum(imageCount);
          const newArray = [...pageItem, ...pages];

          setPageItem(newArray);
          setItemNum(imageCount);
        } else {
          sethasHigh(false);
        }
      } catch (error) {}
    }
  };

  if (!error && page.length !== 0 && web && !loading) {
    if (page.pageType === "normalPage") {
      return (
        <div className={Global.TYPE === "News" ? "app_news" : "app_ott"}>
          <Suspense fallback={<CarouselContentLoader></CarouselContentLoader>}>
            <Head
              title={page.displayName}
              quote={page.displayName}
              description={page.description}
              image={
                page.bannerImage != null
                  ? getAWSUrl() + page.bannerImage.imagekey
                  : ""
              }
              icon={Global.WEBICON ? getAWSUrl() + Global.WEBICON : ""}
            ></Head>
            <InfiniteScroll
              dataLength={pageItem.length}
              hasMore={hasHigh}
              loader={<Listloader></Listloader>}
              next={fetchData}
              // scrollThreshold={0.8}
            >
              <ErrorBoundary>
                {pageItem.length > 0
                  ? pageItem.map((elem, index) =>
                      index === 0 &&
                      (elem.itemid.elementType === "multiCarousel" ||
                        elem.itemid.elementType === "newsCarousel" ||
                        elem.itemid.elementType === "movieCarousel") ? (
                        <div
                          className={
                            Global.TYPE === "News" ? "newsheader" : "ottheader"
                          }
                          key={index}
                        >
                          {" "}
                          <Element
                            information={elem.itemid}
                            type={elem.itemid.elementType}
                            id={elem.itemid._id}
                            name={elem.itemid.urlName}
                            index={index}
                            {...props}
                          ></Element>
                        </div>
                      ) : index === 0 &&
                        elem.itemid.elementType === "3dCarousel" ? (
                        <div
                          className={
                            Global.TYPE === "News" ? "newsthree" : "ottthree"
                          }
                          key={index}
                        >
                          {" "}
                          <Element
                            information={elem.itemid}
                            type={elem.itemid.elementType}
                            id={elem.itemid._id}
                            name={elem.itemid.urlName}
                            index={index}
                            {...props}
                          ></Element>
                        </div>
                      ) : index === 0 ? (
                        <div
                          className={
                            Global.TYPE === "News" ? "newsfinal" : "ottfinal"
                          }
                          key={index}
                        >
                          {" "}
                          <Element
                            information={elem.itemid}
                            type={elem.itemid.elementType}
                            id={elem.itemid._id}
                            ids={elem.itemid._id}
                            name={elem.itemid.urlName}
                            index={index}
                            {...props}
                          ></Element>
                        </div>
                      ) : InPlayer.Account.isAuthenticated() &&
                        Global.RPB &&
                        index === 1 &&
                        props.match.params.urlName === "home" ? (
                        <div key={index}>
                          {" "}
                          <CLandscapeSlider
                            titleCard={true}
                            {...props}
                          ></CLandscapeSlider>
                          <Element
                            information={elem.itemid}
                            type={elem.itemid.elementType}
                            id={elem.itemid._id}
                            ids={elem.itemid._id}
                            name={elem.itemid.urlName}
                            index={index}
                            {...props}
                          ></Element>
                        </div>
                      ) : (
                        <div key={index}>
                          {" "}
                          <Element
                            information={elem.itemid}
                            type={elem.itemid.elementType}
                            id={elem.itemid._id}
                            ids={elem.itemid._id}
                            name={elem.itemid.urlName}
                            index={index}
                            {...props}
                          ></Element>
                        </div>
                      )
                    )
                  : ""}
              </ErrorBoundary>
            </InfiniteScroll>
            {tickStatus.toString() === "200" && tick != null && tick !== "" ? (
              <Ticker
                id={"ticker" + 20}
                tickData={tick}
                key={tick.ticker._id}
                {...props}
              ></Ticker>
            ) : (
              ""
            )}
          </Suspense>
        </div>
      );
    } else if (page.pageType === "seasonPage") {
      return (
        <div>
          <Suspense fallback={<CarouselContentLoader></CarouselContentLoader>}>
            <Head
              title={page.displayName}
              quote={page.displayName}
              description={page.description}
              image={
                page.bannerImage != null
                  ? getAWSUrl() + page.bannerImage.imagekey
                  : ""
              }
            ></Head>

            <Banner
              data={page}
              image={page.bannerImage ? page.bannerImage.imagekey : ""}
              {...props}
            ></Banner>
            <div></div>
            <DetailsTab
              key={page._id}
              idet={"related"}
              type={"season"}
              active={"episodes"}
              data={page.items}
              detail={page}
              id={page.recommendation}
              ally={true}
              {...props}
            ></DetailsTab>
            {tickStatus.toString() === "200" && tick != null && tick !== "" ? (
              <Ticker
                id={"ticker" + 20}
                tickData={tick}
                key={tick.ticker._id}
              ></Ticker>
            ) : (
              ""
            )}
          </Suspense>

          {/* <CrewSlider title={"Cast and Crew"} image={true} id={"castid"}></CrewSlider> */}
        </div>
      );
    } else if (page.pageType === "articlePage") {
      return (
        <div className={Global.TYPE === "News" ? "news_article" : ""}>
          <Suspense fallback={<CarouselContentLoader></CarouselContentLoader>}>
            <Head
              title={page.displayName}
              quote={page.displayName}
              description={page.description}
              image={
                page.bannerImage != null
                  ? getAWSUrl() + page.bannerImage.imagekey
                  : ""
              }
            ></Head>
            <Container>
              <Row>
                <Col sm={12}>
                  <ArticleHeader
                    title={page.mainHeader}
                    author={page.author}
                    publishDate={page.publishDate}
                    details={page}
                    {...props}
                  ></ArticleHeader>
                  {page.blockQuote !== null &&
                  page.blockQuote !== undefined &&
                  page.blockQuote !== "" ? (
                    <BlockQuote
                      quote={page.blockQuote}
                      cite={page.cite}
                    ></BlockQuote>
                  ) : (
                    ""
                  )}
                  {page.introduction !== null &&
                  page.introduction !== undefined &&
                  page.introduction !== "" ? (
                    <TextView
                      header={false}
                      textView={page.introduction}
                      fontSize={"15px"}
                    ></TextView>
                  ) : (
                    ""
                  )}
                  {page.bannerImage !== null &&
                  page.bannerImage !== undefined &&
                  page.bannerImage !== "" &&
                  page.items.length === 0 ? (
                    <ImageView
                      src={
                        page.bannerImage
                          ? getAWSUrl() + page.bannerImage.imagekey
                          : ""
                      }
                    ></ImageView>
                  ) : (
                    ""
                  )}
                  {page.items !== null && page.items !== undefined ? (
                    <ImageSlider
                      id={page.urlName}
                      multiple={false}
                      artImage={page.items}
                      {...props}
                    ></ImageSlider>
                  ) : (
                    ""
                  )}
                  {page.sectionDescription1 !== null &&
                  page.sectionDescription1 !== undefined &&
                  page.sectionDescription1 !== "" ? (
                    <TextView
                      header={true}
                      title={page.sectionHeader1}
                      textView={page.sectionDescription1}
                      fontSize={"15px"}
                    ></TextView>
                  ) : (
                    ""
                  )}
                  {page.videoId !== null &&
                  page.videoId !== undefined &&
                  page.videoId !== "" ? (
                    <ArticlePlayer videoId={page.videoId}></ArticlePlayer>
                  ) : (
                    ""
                  )}
                  {page.sectionDescription2 !== null &&
                  page.sectionDescription2 !== undefined &&
                  page.sectionDescription2 !== "" ? (
                    <TextView
                      header={true}
                      title={page.sectionHeader2}
                      textView={page.sectionDescription2}
                      fontSize={"15px"}
                    ></TextView>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
            </Container>
            <div style={{ marginTop: "10px" }}>
              {page.recommendation != null &&
              (page.recommendation.items.length > 0 ||
                page.recommendation.playlist !== "") ? (
                <ArticleSlider
                  information={page.recommendation}
                  name={"related_article"}
                  description={true}
                  news={true}
                  tag={true}
                  {...props}
                ></ArticleSlider>
              ) : (
                ""
              )}
            </div>
            {tickStatus.toString() === "200" && tick != null && tick !== "" ? (
              <Ticker
                id={"ticker" + 20}
                tickData={tick}
                key={tick.ticker._id}
              ></Ticker>
            ) : (
              ""
            )}
          </Suspense>
        </div>
      );
    } else if (page.pageType === "livePage") {
      return (
        <div className="watchClass">
          <Suspense fallback={<CarouselContentLoader></CarouselContentLoader>}>
            <Head
              title={page.displayName}
              quote={page.displayName}
              description={page.description}
              image={
                page.bannerImage != null
                  ? getAWSUrl() + page.bannerImage.imagekey
                  : ""
              }
            ></Head>
            <Helmet>
              <style type="text/css">{`
        header
        {
            display:none;
        }
        .main-footer
        {
            display:none;
        }
      `}</style>
            </Helmet>
            {Global.LIVE === "JWPlayer" ? (
              <JWPlayer
                library={
                  "https://cdn.jwplayer.com/libraries/" + Global.FSP + ".js"
                }
                file={page.livePage}
              />
            ) : (
              <LiveFull url={page.livePage}></LiveFull>
            )}

            <div
              style={{ transition: "opacity 0.25s ease-in-out 0s", opacity: 1 }}
            >
              <div className="back_wrapper">
                <div className="back_wrap">
                  <div
                    className="_backbutton _backCrypto"
                    aria-label="Back"
                    role="button"
                    tabIndex={0}
                    onClick={goBack}
                  >
                    <svg
                      className="_backSvg"
                      viewBox="0 0 24 24"
                      focusable="false"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g>
                        <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
                      </g>
                    </svg>
                  </div>
                  <div>
                    <h2 className="_backHeading">{page.displayName}</h2>
                    <div className="_backSub">
                      <div className="_backSubed">{t("label_Live")}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {tickStatus.toString() === "200" && tick != null && tick !== "" ? (
              <Ticker
                id={"ticker" + 20}
                key={tick.ticker._id}
                tickData={tick}
              ></Ticker>
            ) : (
              ""
            )}
          </Suspense>
        </div>
      );
    } else if (page.pageType === "videoPage") {
      return page.videoId !== null ? (
        <div>
          {Global.VCMS === "YouTube" ? (
            <Suspense
              fallback={<CarouselContentLoader></CarouselContentLoader>}
            >
              <Head
                title={page.displayName}
                quote={page.displayName}
                description={page.description}
                image={
                  page.bannerImage != null
                    ? getAWSUrl() + page.bannerImage.imagekey
                    : ""
                }
              ></Head>

              {vData ? (
                <div className="demoClass">
                  <div className="boxImage">
                    <div className="boxOverlay">
                      <div className="row">
                        <div className="col-xl-8 col-md-7 fullmax">
                          <div className="boxFull">
                            <YoutubePlayer
                              header={true}
                              videoId={vData.items[0].id}
                              videoData={vData}
                              {...props}
                            ></YoutubePlayer>
                          </div>
                          <div className="boxedcontainer">
                            <YoutubeDetails
                              data={vData.items[0]}
                              {...props}
                            ></YoutubeDetails>
                          </div>
                        </div>

                        <div
                          className="col-xl-4 col-md-5 halfmax"
                          style={{ background: "var(--iq-rgba-second-body)" }}
                        >
                          <YoutubeList
                            header={true}
                            app={props.match.params.AppId}
                            {...props}
                          ></YoutubeList>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="mt-2">
                
        
                 
                </div> */}
                </div>
              ) : (
                ""
              )}

              {tickStatus.toString() === "200" &&
              tick != null &&
              tick !== "" ? (
                <Ticker
                  id={"ticker" + 20}
                  tickData={tick}
                  key={tick.ticker._id}
                ></Ticker>
              ) : (
                ""
              )}

              {/* <CrewSlider title={"Cast and Crew"} image={true} id={"castid"}></CrewSlider> */}
            </Suspense>
          ) : (
            <Suspense
              fallback={<CarouselContentLoader></CarouselContentLoader>}
            >
              <Head
                title={page.displayName}
                quote={page.displayName}
                description={page.description}
                image={
                  page.bannerImage != null
                    ? getAWSUrl() + page.bannerImage.imagekey
                    : ""
                }
              ></Head>

              {vData ? (
                <MovieBanner
                  dataId={page.videoId}
                  newData={vData}
                  banData={vPlay}
                  {...props}
                ></MovieBanner>
              ) : (
                ""
              )}
              <MovieTab
                videoId={page.videoId}
                idet={"related"}
                type={"movie"}
                active={"more_details"}
                data={vPlay}
                recomm={vPlay.Recommendation}
                {...props}
              ></MovieTab>
              {tickStatus.toString() === "200" &&
              tick != null &&
              tick !== "" ? (
                <Ticker
                  id={"ticker" + 20}
                  tickData={tick}
                  key={tick.ticker._id}
                ></Ticker>
              ) : (
                ""
              )}

              {/* <CrewSlider title={"Cast and Crew"} image={true} id={"castid"}></CrewSlider> */}
            </Suspense>
          )}
        </div>
      ) : (
        <div>
          <Suspense fallback={<CarouselContentLoader></CarouselContentLoader>}>
            <NotFound code={"404"} message={t("label_404_VIDEO")}></NotFound>
          </Suspense>
        </div>
      );
    } else if (page.pageType === "externalPage") {
      return <External ext={page.externalPage} {...props}></External>;
    } else if (page.pageType === "internalPage") {
      return <Internal internal={page.internalPage} {...props}></Internal>;
    } else if (page.pageType === "textPage") {
      return (
        <div>
          <Suspense fallback={<CarouselContentLoader></CarouselContentLoader>}>
            <Head
              title={page.displayName}
              quote={page.displayName}
              description={page.description}
              image={
                page.bannerImage != null
                  ? getAWSUrl() + page.bannerImage.imagekey
                  : ""
              }
            ></Head>
            <TextPage text={page}></TextPage>
            {tickStatus.toString() === "200" && tick != null && tick !== "" ? (
              <Ticker
                id={"ticker" + 20}
                key={tick.ticker._id}
                tickData={tick}
              ></Ticker>
            ) : (
              ""
            )}
          </Suspense>
        </div>
      );
    } else {
      if (!loading) {
        return (
          <div>
            <Suspense
              fallback={<CarouselContentLoader></CarouselContentLoader>}
            >
              <NotFound
                code={"500 ERROR"}
                message={t("label_500_NORMAL")}
                {...props}
              ></NotFound>
            </Suspense>
          </div>
        );
      } else {
        return (
          <div>
            <Suspense
              fallback={<CarouselContentLoader></CarouselContentLoader>}
            >
              <NotFound code={""} message={""} {...props}></NotFound>
            </Suspense>
          </div>
        );
      }
    }
  } else if (!error && page.length === 0) {
    return (
      <div>
        <CarouselContentLoader />
      </div>
    );
  } else if (error && page.length === 0) {
    return (
      <div>
        <Suspense fallback={<CarouselContentLoader></CarouselContentLoader>}>
          <NotFound code={""} message={""} {...props}></NotFound>
        </Suspense>
      </div>
    );
  } else {
    if (!web) {
      return (
        <div>
          <Suspense fallback={<CarouselContentLoader></CarouselContentLoader>}>
            <NotFound
              code={"404"}
              message={t("label_404")}
              {...props}
            ></NotFound>
          </Suspense>
        </div>
      );
    } else if (loading) {
      return (
        <div key={props.match.params.urlName}>
          {" "}
          <CarouselContentLoader />
        </div>
      );
    } else {
      return (
        <div>
          <Suspense fallback={<CarouselContentLoader></CarouselContentLoader>}>
            <NotFound
              code={"500"}
              message={t("label_500")}
              {...props}
            ></NotFound>
          </Suspense>
        </div>
      );
    }
  }
};

export default StartPage;
